import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, Icon, Pagination, Avatar, notification, Empty,Radio } from 'antd';
import { UndoOutlined, CloseOutlined, UserOutlined  } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from 'moment';
import { dueworklistSchema,callLogSchemaDue } from '../../../schema/bill-tacking';
import Select2 from '../../../components/FormComponent/select2';
import Select2multiple from '../../../components/FormComponent/select2/multiple';
import Inputlayer from '../../../components/FormComponent/Input';
import { filter, formData, dissableFormData } from '../../../schema/apppointment';
// import Pagination from "react-js-pagination";
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';

const { addCounsellorComments, getCounsellorCommentsByPatient, homepage}= networkList
const $ = require('jquery');

class Due_worklist extends Component {
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            totalItemsCount: 0,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            downloadtbody: [],
            commentModal: false,
            comments: null,
            patient_details: {},
            commentsArray: [],
            callformSchema:[],
            payer_type:["GENERAL", "INSURANCE"]
        };
    }


    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    componentDidMount() {

        let formSchema = Object.assign({}, dueworklistSchema);
        formSchema['feilds'].map((feild, key) => {
           if (feild.name === 'doctorid') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Doctor';
            } else if (feild.name === 'departmentbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Department';
            }  else if ( feild.name === 'nursestationbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Nurse Station';
            }  else if (feild.name === 'due_payer_type') {
                formSchema['feilds'][key]['value'] = ["GENERAL", "INSURANCE"];
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = ["GENERAL", "INSURANCE"];
            } else if (feild.name === 'due_amount') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Due Amount';
            } else if (feild.name === 'due_percent') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Due Percent';
            } else {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            }


        })
        let callformSchema = Object.assign({}, callLogSchemaDue);
        callformSchema['feilds'].map((feild, key) => {
            if (feild.name === 'remarks') {
                callformSchema['feilds'][key]['value'] = 'remarks';
                callformSchema['feilds'][key]['visable'] = true;
            } else if (feild.name === 'calldata') {
                callformSchema['feilds'][key]['visable'] = true;
                callformSchema['feilds'][key]['value'] =null;
            } else if (feild.name === 'activity_type') {
                callformSchema['feilds'][key]['visible'] = false;
                callformSchema['feilds'][key]['value'] = 'due';
                callformSchema['feilds'][key]['text'] = 'Due';
            } else {
                callformSchema['feilds'][key]['value'] = null;
                callformSchema['feilds'][key]['valid'] = false;
                callformSchema['feilds'][key]['errors'] = [];
                callformSchema['feilds'][key]['visible'] = false;
                delete callformSchema['feilds'][key]['text'];
            }

        })
        localStorage.setItem('activity_type', "due");
        this.setState({ activePage: 1, totalItemsCount: 0, 'formData': formSchema['feilds'],'callformSchema':callformSchema['feilds'] }, () => {
            this.loadPage()
        });
    }

    componentWillUnmount() {
        localStorage.removeItem('activity_type');
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
    }

    loadPage = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, payer_type, bill_value, due_percent, doctor_id, department_name, nurse_station_code } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getDueOutstandingReport } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key": 'ip_no',
                    'label': 'In Patient Number'
                }, {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                }, {
                    "key": 'patient_age',
                    'label': 'Patient Age'
                }, {
                    "key": 'patient_gender',
                    'label': 'Patient Gender'
                }, {
                    "key": 'mobile_number',
                    'label': 'Patient Phone'
                }, {
                    "key": 'approx_bill_amount',
                    'label': 'Current Approx. Bill (Rs.)'
                }, {
                    "key": 'total_advance',
                    'label': 'Total Advance'
                }, {
                    "key": 'due_amount',
                    'label': 'Due Amount (Rs.)'
                }, {
                    "key": 'due_percent',
                    'label': 'Due Percent (%)'
                }, {
                    "key": 'admission_date',
                    'label': 'date of admission',
                }, {
                    "key": 'ward_name',
                    'label': 'ward'
                }, {
                    "key": 'department_name',
                    'label': 'department'
                }, {
                    "key": 'nurse_station_name',
                    'label': 'Nurse Station'
                },
                {
                    "key": 'doctor_name',
                    'label': 'Doctor Name'
                },
                {
                    "key": 'procedure_name',
                    'label': 'procedure'
                },
                {
                    "key": 'sum_insured_amount',
                    'label': 'Sum Insured Amount (Rs.)'
                },
                {
                    "key": 'approvedamount',
                    'label': 'Insurance Approved Amount'
                },
                {
                    "key": 'latest_estimated_amt',
                    'label': 'Last Counselled Amount (Rs.)'
                }, {
                    "key": 'latest_counsellor_name',
                    'label': 'Last Counselled By'
                }, {
                    "key": 'latest_counselled_date',
                    'label': 'Last Counselled Date'
                },
                {
                    "key": 'vip',
                    'label': 'VIP'
                },
                {
                    "key": 'adm_purpose',
                    'label': 'Admission Purpose'
                },
                {
                    "key": 'latest_recno',
                    'label': 'Latest Receipt no.'
                },
                {
                    "key": 'latest_recamt',
                    'label': 'Latest Receipt Amount (Rs.)'
                },
                {
                    "key": 'latest_recdt',
                    'label': 'Latest Receipt Date'
                },
                {
                    "key": 'service_call_off',
                    'label': 'Service Call Off'
                },{
                    "key": 'fc_payer_type',
                    'label': 'FC Payer Type'
                }, 
                {
                    "key": 'hims_payer_type',
                    'label': 'HIMS Payer Type'
                }, {
                    "key": 'privilege_name',
                    'label': 'Privilege Name'
                },
                {
                    "key": 'unit_name',
                    'label': 'Unit Name'
                },
            ]
            
            this.setState((state) => ({ downloadStatus: 0, tbody: [], tableTitle: 'Due Worklist', thead: tableHead, loadding: true, filename: 'Due-Worklist.csv' }), () => {
                postService(getDueOutstandingReport, 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": this.state.search ? this.state.search : "",
                        "counselled_by_id": null,
                        "export": 0, //1 for download excel
                        "page_no": activePage,
                        "payer_type": payer_type ? payer_type : [],
                        "bill_value": bill_value ? bill_value : [],
                        "due_percent": due_percent ? due_percent : [],
                        "doctor_id": doctor_id ? doctor_id : [],
                        "department_name": department_name ? department_name : [],
                        "nurse_station_code": nurse_station_code ? nurse_station_code : []

                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'admission_date' || dataKey === 'latest_counselled_date' || dataKey === 'latest_recdt') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                }
                            })
                        })
                        this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data, loadding: false }));
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    handleChange(ele) {
        console.log(ele);
        var formFeilds = this.state.formData;
        let { search } = this.state
    }
    submit() {
        var formFeilds = this.state.formData;
        let { search } = this.state
        this.setState(({ doctor_id:formFeilds[0].value, department_name:formFeilds[1].value,nurse_station_code:formFeilds[2].value,payer_type: formFeilds[3].value, bill_value: formFeilds[4].value, due_percent: formFeilds[5].value, activePage: 1, }), () => {
            // this.inputRef.value = null;
            this.loadPage()
        })
    }
    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        this.setState((state) => ({ 'search': value }), () => {

        });
    }
    searchClick() {
        this.setState((state) => ({
            activePage: 1,
            tbody: [],
            totalItemsCount: 0,
            doctor_id: [],
            department_name: [],
            payer_type: [],
            bill_value: [],
            due_percent: [],
            ward_type: []
        }), () => {
            this.loadPage();
            var formFeilds = this.state.formData;
            formFeilds.map((feild, key) => {

                if (feild.name === 'due_payer_type') {
                    formFeilds[key]['value'] = ["GENERAL", "INSURANCE"];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = ["GENERAL", "INSURANCE"];
                } else if (feild.name === 'due_amount') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Due Amount';
                } else if (feild.name === 'due_percent') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Due Percent';
                } else {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    delete formFeilds[key]['text'];
                }
            })
            this.setState({ formData: formFeilds })
        })
    }

    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            activePage: page,
            tbody: []
        }), () => {
            this.loadPage();
        })
    }
    downloadFile = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, payer_type, bill_value, due_percent, ward_type, doctor_id, department_name, nurse_station_code } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getDueOutstandingReport } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key": 'ip_no',
                    'label': 'In Patient Number'
                }, {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                }, {
                    "key": 'patient_age',
                    'label': 'Patient Age'
                }, {
                    "key": 'patient_gender',
                    'label': 'Patient Gender'
                }, {
                    "key": 'mobile_number',
                    'label': 'Patient Phone'
                }, {
                    "key": 'approx_bill_amount',
                    'label': 'Current Approx. Bill (Rs.)'
                }, {
                    "key": 'total_advance',
                    'label': 'Total Advance'
                }, {
                    "key": 'due_amount',
                    'label': 'Due Amount (Rs.)'
                }, {
                    "key": 'due_percent',
                    'label': 'Due Percent (%)'
                }, {
                    "key": 'admission_date',
                    'label': 'date of admission',
                }, {
                    "key": 'ward_name',
                    'label': 'ward'
                }, {
                    "key": 'department_name',
                    'label': 'department'
                },
                {
                    "key": 'nurse_station_name',
                    'label': 'Nurse Station'
                },
                {
                    "key": 'doctor_name',
                    'label': 'Doctor Name'
                },
                {
                    "key": 'procedure_name',
                    'label': 'procedure'
                },
                {
                    "key": 'sum_insured_amount',
                    'label': 'Sum Insured Amount (Rs.)'
                },
                {
                    "key": 'approvedamount',
                    'label': 'Insurance Approved Amount'
                },
                {
                    "key": 'latest_estimated_amt',
                    'label': 'Last Counselled Amount (Rs.)'
                }, {
                    "key": 'latest_counsellor_name',
                    'label': 'Last Counselled By'
                }, {
                    "key": 'latest_counselled_date',
                    'label': 'Last Counselled Date'
                },
                {
                    "key": 'vip',
                    'label': 'VIP'
                },
                {
                    "key": 'adm_purpose',
                    'label': 'Admission Purpose'
                },
                {
                    "key": 'latest_recno',
                    'label': 'Latest Receipt no.'
                },
                {
                    "key": 'latest_recamt',
                    'label': 'Latest Receipt Amount (Rs.)'
                },
                {
                    "key": 'latest_recdt',
                    'label': 'Latest Receipt Date'
                },
                {
                    "key": 'service_call_off',
                    'label': 'Service Call Off'
                },  {
                    "key": 'fc_payer_type',
                    'label': 'FC Payer Type'
                }, 
                {
                    "key": 'hims_payer_type',
                    'label': 'HIMS Payer Type'
                }, {
                    "key": 'privilege_name',
                    'label': 'Privilege Name'
                },
                {
                    "key": 'unit_name',
                    'label': 'Unit Name'
                },
                {
                    "key": 'approvedamount',
                    'label': 'Insurance Approved Amount'
                },
            ]
            This.setState((state) => ({ downloadStatus: 0, thead: tableHead, loadding: true, filename: 'Due-Worklist.csv' }), () => {
                postService(getDueOutstandingReport, 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": This.state.search ? This.state.search : "",
                        "counselled_by_id": null,
                        "export": 1, //1 for download excel
                        "page_no": 0,
                        "payer_type": payer_type ? payer_type : [],
                        "bill_value": bill_value ? bill_value : [],
                        "due_percent": due_percent ? due_percent : [],
                        "doctor_id": doctor_id ? doctor_id : [],
                        "department_name": department_name ? department_name : [],
                        "nurse_station_code": nurse_station_code ? nurse_station_code : []
                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {                        
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'admission_date' || dataKey === 'latest_counselled_date' || dataKey === 'latest_recdt') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                }else if (dataKey === 'service_call_off') {
                                    if ((res.data[key][dataKey] && res.data[key][dataKey] !== '-' && res.data[key][dataKey] === 'N')) {
                                        res.data[key][dataKey] = res.data[key][dataKey] ? 'NO' : 'NA'                                        
                                    } else if ((res.data[key][dataKey] && res.data[key][dataKey] !== '-' && res.data[key][dataKey] === 'Y')) {
                                        res.data[key][dataKey] = res.data[key][dataKey] ? 'YES' : 'NA'                                        
                                    }
                                    res.data[key][dataKey] = res.data[key][dataKey] && res.data[key][dataKey] !== '-' ? res.data[key][dataKey] : 'NA'                                        
                                }
                                else {
                                    res.data[key][dataKey] = res.data[key][dataKey] && res.data[key][dataKey] !== '-' ? res.data[key][dataKey] : 'NA'
                                }

                            })
                        })
                        This.setState((state) => ({ downloadtbody: res.data, loadding: false, downloadStatus: 1 }));
                        this.csvLink.current.link.click();
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    clearFilter = () => {
        this.setState(() => ({ doctor_id: '', department_name: '', payer_type: '', nurse_station_code: '',bill_value: '', due_percent: '', ward_type: '', search: '', activePage: 1, totalItemsCount: 0 }),
            () => {
                // this.inputRef.value = null;
                var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Doctor';
                    } else if (feild.name === 'departmentbyunit') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Department';
                    }  else if ( feild.name === 'nursestationbyunit') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Nurse Station';
                    }  else if (feild.name === 'due_payer_type') {
                        formFeilds[key]['value'] = ["GENERAL", "INSURANCE"];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = ["GENERAL", "INSURANCE"];
                    } else if (feild.name === 'due_amount') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Due Amount';
                    } else if (feild.name === 'due_percent') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Due Percent';
                    } else {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds })
                this.loadPage();
            })

    }
    commentsModal = (data) => {
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        try{
        This.setState((state) => ({  commentModal: true, patient_details: data, loadding: true }), () => {
            postService(getCounsellorCommentsByPatient, 'POST', {
                "data":{
                    "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                    "ip_no": data.ip_no ? data.ip_no : null
                }
            }).then(res => {
                console.log('comments:', res);                
                if (res.status) {                    
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': res['data']}));                    
                } else {
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': [] }));
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                        zIndex: 1022
                    });
                }
            });
        });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Failure',
            content: "Oops, something went wrong... Please try again.",
            zIndex: 1022
        });
    }        
    }

    comments(event) {
        let value = event.target.value;
        this.setState((state) => ({ 'comments': value ? value : null }));
    }

    submitCommint=()=>{
        let{comments, patient_details,callformSchema}=this.state
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        let errors = this.validateModalFeilds(callformSchema);
        let call_log, activity_type, call_log_eda, call_log_category, call_log_reason, call_back_date,
            call_log_surgery_date, call_log_ip_no;
        callformSchema.map((item, key) => {
            if (item.name === 'calldata') {
                call_log = item.value;
            }
            if (item.name === 'activity_type') {
                activity_type = item.value;
            }
            if (item.name === 'category') {
                call_log_category = item.value;
            }
           

        })
        let payload = {
            "ip_no": patient_details.ip_no ? patient_details.ip_no : null,
            "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
            "comment": comments?comments:null,
            "comment_from": activity_type ? activity_type : null,
            "call_log": call_log ? true : false,
            "call_log_eda":  null,
            "call_back_date":  null,
            "call_log_surgery_date":  null,
            "call_log_category": call_log_category ? call_log_category.toString() : null,
            "call_log_ip_no":  null,
            "call_log_reason":  null,
            "admission_id":patient_details.admission_id?patient_details.admission_id:null,
            "doctor_id":patient_details.doctor_id?patient_details.doctor_id:null,
            "is_iccu":patient_details.is_iccu?patient_details.is_iccu:null
        }
       
        if (call_log!==null && !errors.includes(false)) {
            try {
                This.setState((state) => ({ loadding: true }), () => {
                    postService(addCounsellorComments, 'POST', {
                        "data": payload
                    }).then(res => {
                        console.log('comments:', res);
                        if (res.status) {
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : "Success",
                                zIndex: 1022
                            });
                            callformSchema.map((feild, key) => {
                                if (feild.name === 'remarks') {
                                    callformSchema[key]['value'] = 'remarks';
                                    callformSchema[key]['visible'] = true;
                                } else if (feild.name === 'calldata') {
                                    callformSchema[key]['visible'] = true;
                                    callformSchema[key]['value'] = null;
                                } else if (feild.name === 'activity_type') {
                                    callformSchema[key]['visible'] = false;
                                    callformSchema[key]['value'] = 'due';
                                    callformSchema[key]['text'] = 'Due';
                                } else {
                                    callformSchema[key]['value'] = null;
                                    callformSchema[key]['valid'] = false;
                                    callformSchema[key]['errors'] = [];
                                    callformSchema[key]['visible'] = false;
                                    delete callformSchema[key]['text'];
                                }
                            })
                            This.setState((state) => ({ 'loadding': false, comments: null, 'callformSchema': callformSchema }));
                            This.commentsModal(patient_details)
                        } else {
                            This.setState((state) => ({ 'loadding': false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                                zIndex: 1022
                            });
                        }
                    });
                });
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }
        }

        if(call_log===null ){
            if(comments && comments.length > 12){
                try {
                    This.setState((state) => ({ loadding: true }), () => {
                        postService(addCounsellorComments, 'POST', {
                            "data": payload
                        }).then(res => {
                            console.log('comments:', res);
                            if (res.status) {
                                Modal.success({
                                    title: 'Success',
                                    content: res.message ? res.message : "Success",
                                    zIndex: 1022
                                });
                                callformSchema.map((feild, key) => {
                                    if (feild.name === 'remarks') {
                                        callformSchema[key]['value'] = 'remarks';
                                        callformSchema[key]['visible'] = true;
                                    } else if (feild.name === 'calldata') {
                                        callformSchema[key]['visible'] = true;
                                        callformSchema[key]['value'] = null;
                                    } else if (feild.name === 'activity_type') {
                                        callformSchema[key]['visible'] = false;
                                        callformSchema[key]['value'] = 'due';
                                        callformSchema[key]['text'] = 'Due';
                                    } else {
                                        callformSchema[key]['value'] = null;
                                        callformSchema[key]['valid'] = false;
                                        callformSchema[key]['errors'] = [];
                                        callformSchema[key]['visible'] = false;
                                        delete callformSchema[key]['text'];
                                    }
                                })
                                This.setState((state) => ({ 'loadding': false, comments: null, 'callformSchema': callformSchema }));
                                This.commentsModal(patient_details)
                            } else {
                                This.setState((state) => ({ 'loadding': false }));
                                Modal.error({
                                    title: 'Failure',
                                    content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                                    zIndex: 1022
                                });
                            }
                        });
                    });
                } catch (error) {
                    console.log(error);
                    this.setState((state) => ({ 'loadding': false }));
                    Modal.error({
                        title: 'Failure',
                        content: "Oops, something went wrong... Please try again.",
                    });
                } 
               }else{
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: 'Please enter comment briefly.',
                    zIndex: 1022
                }) 
            }
        }
    }
    onChange(type, evet) {
        console.log(evet, type);
        let { callformSchema } = this.state
        callformSchema.map((item, key) => {
            if (type.name === 'remarks') {
                if (item.name === 'remarks') {
                    callformSchema[key]['value'] = 'remarks';
                }
                if (item.name === 'calldata') {
                    callformSchema[key]['value'] = null;
                } else {
                    if (item.name === 'remarks' || item.name === 'calldata') {
                        callformSchema[key]['visible'] = true;
                    } else {
                        callformSchema[key]['visible'] = false;
                    }
                }
            }
            if (type.name === 'calldata') {
                localStorage.setItem('activity_type', "due");
                if (item.name === 'calldata') {
                    callformSchema[key]['value'] = 'calldata';
                }
                if (item.name === 'remarks') {
                    callformSchema[key]['value'] = null;
                }
                if (item.name === 'activity_type') {
                    callformSchema[key]['visible'] = true;
                }
                if (item.name === 'category') {
                    callformSchema[key]['visible'] = true;
                    callformSchema[key]['value'] = null;
                    callformSchema[key]['text'] = null;
                }
            }
        })
        console.log('callformSchema', callformSchema);
        this.setState({ 'callformSchema': callformSchema })
    }
    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'input' || feild['element'] === "select2" || feild['element'] === 'Select2multiple' || feild['element'] === 'datepicker')) {
                formFeilds[key]['errors'] = [];
                if (!feild.disable && feild.visible) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {

                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                            else {
                                console.log('no', feild['name'], feild['value'])
                                formFeilds[key]['errors'] = [];
                                errors.push(true);
                            }
                        })

                }
            }
        })

        this.setState((state) => ({ callformSchema: formFeilds }));
        return errors;
    }
    historyModelClose() {
        let { callformSchema } = this.state
        callformSchema.map((feild, key) => {
            if (feild.name === 'remarks') {
                callformSchema[key]['value'] = 'remarks';
                callformSchema[key]['visible'] = true;
            } else if (feild.name === 'calldata') {
                callformSchema[key]['visible'] = true;
                callformSchema[key]['value'] = null;
            } else if (feild.name === 'activity_type') {
                callformSchema[key]['visible'] = false;
                callformSchema[key]['value'] = 'due';
                callformSchema[key]['text'] = 'Due';
            } else {
                callformSchema[key]['value'] = null;
                callformSchema[key]['valid'] = false;
                callformSchema[key]['errors'] = [];
                callformSchema[key]['visible'] = false;
                delete callformSchema[key]['text'];
            }
        })
        this.setState({ commentModal: false, comments: null, callformSchema: callformSchema })
    }
    render() {
        let { tableTitle, thead, activePage, tbody, downloadtbody, filename, formData, totalItemsCount, downloadStatus, commentModal, comments, patient_details, commentsArray, loadding,callformSchema } = this.state;
        console.log('callformSchema',callformSchema);
        return (
            <div>
                <div className="clearfix mx-5">
                    <div className="float-left pt-2">
                        {tableTitle}
                    </div>
                    {
                        downloadStatus && tbody != ''
                            ?
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download worklist</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined className="align-middle pr-2" /><span> Clear</span></button>
                                <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></button>
                            </div>
                            :
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download worklist</span></Button>
                                <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined type="reload" className="align-middle pr-2" /><span> Clear</span></button>
                                <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></Button>
                            </div>
                    }
                </div>

                <Spin spinning={loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="row">
                                    {(formData !== undefined) && <React.Fragment>

                                        {formData
                                            .map((feild, key) => {

                                                if (feild.element === 'input') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                <div className="input-group" key={key}>
                                                                    {/* <input type="text" id="myInput" className="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" /> */}
                                                                    <div
                                                                        className='w-100'
                                                                        key={key}>
                                                                        <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" onBlur={this.searchChange.bind(this)} ref={(inputRef => (this.inputRef = inputRef))} />
                                                                        <div class="input-group-append" style={{ position: 'absolute', right: 0, height: '32px', top: 0 }}>
                                                                            <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="input-group-append" style={{position: 'absolute', right: 0, height: '32px'}}>                                                                    
                                                                    <button className="btn btn-primary btn-sm" onClick={this.search}><img src="/assets/images/icons/search.png" /></button>
                                                                </div> */}
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                {/* <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p> */}
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this)}
                                                                /> {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'select2multiple' && feild.visible) {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                <Select2multiple
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this, feild)}
                                                                /> {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                            })}

                                    </React.Fragment>}
                                </div>
                            </div>
                        </div>
                        <div className="financial-table table-responsive sticky-header" id="table">
                            <table className="table table-hover table-bordered mb-0 track-bills bg-white">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize align-middle">s.no.</td>
                                        {thead.map((head, key) => {
                                            return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                                return (<tr key={key}>
                                                    <td>{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {
                                                        if (head['key'] === 'ip_no') {
                                                            return (<td key={Hkey} className="text-capitalize"><p style={{ 'cursor': 'pointer','color': 'blue' }}  onClick={()=>{this.commentsModal(body)}}>{body[head['key']] ? body[head['key']] : 'NA'}</p></td>);

                                                        }
                                                        if (head['key'] === 'service_call_off') {
                                                            if ((body[head['key']] && body[head['key']] !== '-' && body[head['key']] === 'N')) {
                                                                return (<td key={Hkey} className="text-capitalize">{(body[head['key']] && body[head['key']] !== '-' && body[head['key']] === 'N') ? 'NO' : 'NA'}</td>);
                                                            } else if ((body[head['key']] && body[head['key']] !== '-' && body[head['key']] === 'Y')) {
                                                                return (<td key={Hkey} className="text-capitalize">{(body[head['key']] && body[head['key']] !== '-' && body[head['key']] === 'Y') ? 'YES' : 'NA'}</td>);
                                                            }
                                                            return (<td key={Hkey} className="text-capitalize">{(body[head['key']] && body[head['key']] !== '-') ? body[head['key']] : 'NA'}</td>);
                                                        }
                                                        return (<td key={Hkey} className="text-capitalize">{(body[head['key']] && body[head['key']] !== '-') ? body[head['key']] : 'NA'}</td>);
                                                    })
                                                    }
                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>

                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />
                        </div>
                    </div>
                    <Modal
                        title=''
                        centere
                        footer={null}
                        width='80%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        visible={commentModal}>
                            <Spin spinning={loadding}>
                            <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => { this.historyModelClose() }} /></Tooltip>
                        <h4 className="text-center pb-4">Comments History</h4>
                        <div className="row pb-3">
                            <div className="col-7 my-auto">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_details.patient_name ? patient_details.patient_name : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="UMR Number">{patient_details.umr_no ? patient_details.umr_no : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="IP Number">{patient_details.ip_no ? patient_details.ip_no : '--'}</Tooltip></h6>
                            </div>
                            <div className="col-5 my-auto">
                                    <div className="row">
                                        {callformSchema && callformSchema.map((feild, key) => {
                                            if (feild.visible && feild.element === 'radio') {
                                                return (
                                                    <div class={feild.name === 'remarks' ? "col-8 fontSize text-right p-0" : "col-4 fontSize text-right pl-0"}>
                                                        <Tooltip title={feild.name === 'remarks' ? "Click Remarks" : "Click Call Log"}><Radio.Button className='btn px-2 mx-1' onChange={this.onChange.bind(this, feild)}
                                                            checked={
                                                                feild.value ? true : false}
                                                        >{feild.name === 'remarks' ? <i class="fa fa-file-text pr-1" aria-hidden="true"></i> : <i class="fa fa-phone pr-1" aria-hidden="true"></i>}{feild.title}</Radio.Button></Tooltip>
                                                        {feild.errors.map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger" style={{ bottom: '-15px' }}>{error.message}</small>
                                                            );
                                                        })}
                                                    </div>
                                                )
                                            }
                                        })}
                                    </div>
                                </div>                     
                        </div>
                        <div className='bg-white white-board'>
                                <div className="row w-100 mx-auto labelColorChange">
                                    {callformSchema && callformSchema.map((feild, key) => {
                                        if (feild.visible && feild.element === 'select2') {
                                            return (
                                                <div class="col-4 mt-3">
                                                    <label className="data-label w-100">{feild.title}</label>
                                                    <Select2
                                                        selectdata={feild}
                                                        changedObj={this.state.changedObj}
                                                        {...this.props}
                                                        {...this.state}
                                                        Queuedata={this.state.formData}
                                                        onselectChanges={this
                                                            .handleChange
                                                            .bind(this)} />
                                                    {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}

                                                </div>
                                            )
                                        }
                                    })}
                            <div class="col-12  mt-3 mb-3">
                                <textarea placeholder="Enter your comments..." autoFocus='true' className="textarea" style={{height: '80px'}} value={comments ? comments : ''} onChange={(event) => this.comments(event)}></textarea>
                            </div> 
                            </div>                          
                        </div>
                        <div className="text-center  mt-3 mb-4">
                            <button className="btn btn-success" onClick={()=>{this.submitCommint()}}>Submit</button>
                            </div>
                            <div class="row pt-3 w-100 mx-auto bg-white white-board">
                            <h5 className='pl-3 pb-3 pt-3'>History</h5>
                                {commentsArray.length>0&&commentsArray.map((data, key) => {
                                    return <div className="col-12 pb-1">
                                        <div class={commentsArray.length-1!==key?"media hr-call-log":"media"}>
                                            {/* <img src="https://www.w3schools.com/bootstrap4/img_avatar3.png" style={{ 'width': '60px' }} /> */}
                                            <div class="align-self-start mr-3">
                                                <Avatar size={50} icon={<UserOutlined />} className="align-middle" /><br></br>
                                            </div>
                                            <div class="media-body">
                                                <div className='row'>
                                                    <div className='col-12'>
                                                    <h6>
                                                    <Tooltip title="Created By"><small className="text-capitalize">{data.created_by}</small></Tooltip><span className="mx-3">|</span> 
                                                    <Tooltip title='Created On'><small>{moment(data.created_at).format('DD-MM-YYYY hh:mm A')}</small></Tooltip> <span className="mx-3">|</span> 
                                                    <Tooltip title="Comment From"><small className="text-capitalize">{data.remarks_from}</small></Tooltip>
                                                    </h6>  
                                                    </div>
                                                    <div className='col-8'>
                                                <h6 className='mb-1'>
                                                {data.category_name!=="null"&&data.category_name!==null?<Tooltip title="Category"><small className="text-capitalize "> {data.category_name}</small></Tooltip>:''}
                                                </h6>
                                                </div>
                                                <div className='col-12'>
                                                <p>{data.remarks}</p>
                                                </div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                })}
                                {commentsArray && commentsArray.length == 0 && <Empty className="mx-auto" description={<span>No history is available for this patient.</span>} />}
                            </div>
                        </Spin>
                    </Modal>
                
                </Spin>
            </div>
        )
    }
}

export default Due_worklist;